import { render, staticRenderFns } from "./integralRecord.vue?vue&type=template&id=15cead02&scoped=true"
import script from "./integralRecord.vue?vue&type=script&lang=js"
export * from "./integralRecord.vue?vue&type=script&lang=js"
import style0 from "./integralRecord.vue?vue&type=style&index=0&id=15cead02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cead02",
  null
  
)

export default component.exports